const initialState = {
  loading: false,
  error: null,
  forgotPassword: null,
};

const ForgotPasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FORGOT_PASSWORD_LOADING":
    case "LOADING":
    case "LODING":
      return {
        ...state,
        loading: action.payload,
      };

    case "ADD_FORGOT_PASSWORD_EMAIL_SUCCESS":
      return {
        ...state,
        forgotPassword: action.payload,
        error: null,
        loading: false,
      };

    case "ADD_FORGOT_PASSWORD_EMAIL_FAILURE":
    case "ADD_RESET_PASSWORD_FAILURE":
    case "SEND_RESEND_OTP_FAILURE":
      return {
        ...state,
        error: action.payload?.error || action.payload,
        loading: false,
      };

    case "ADD_RESET_PASSWORD_SUCCESS":
    case "SEND_RESEND_OTP_SUCCESS":
      return {
        ...state,
        error: null,
        loading: false,
      };

    default:
      return state;
  }
};

export default ForgotPasswordReducer;
